import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';

import CollectionController from 'cio/pods/collections/collection/controller';
import CollectionModel from 'cio/models/collection';
import Transition from '@ember/routing/-private/transition';
import DS from 'ember-data';

export type CollectionParams = { collection_id: string };

export default class CollectionRoute extends Route {
  @service store!: DS.Store;

  crumb() {
    let collection = this.modelFor('collections.collection') as CollectionModel;

    return {
      name: collection.name,
      path: 'collections.collection',
      model: collection,
    };
  }

  model({ collection_id: collectionId }: CollectionParams) {
    return this.store.findRecord('collection', collectionId);
  }

  setupController(controller: CollectionController, model: CollectionModel, transition: Transition) {
    super.setupController(controller, model, transition);
    controller.setDefaults();
  }
}
